
<app-menu-side *ngIf="menuData" class="navbar-default navbar-static-side" role="navigation">
  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">
        <li class="nav-header">
          <div class="profile-element" dropdown>
            <div style="border-radius: 5px; padding: 0px">
              <img alt="image" class="full-width" src="assets/images/liqüi_logo_blanco.png"  style="padding-right: 10px">
              <!-- <img alt="image" width="80" src="assets/images/Ü_logo cuadrado_gradient.png">  -->

            </div>
            <a dropdownToggle class="dropdown-toggle menu-profile" href="#">
              <span class="block m-t-xs font-bold">{{nombreUser}} {{apellidoUser}} <b class="caret"></b></span>
            </a>
            <ul class="dropdown-menu animated fadeInRight  show" *dropdownMenu>
              <!-- <li><a href="#">Perfil</a></li> -->
              <!-- <li><a href="#">Contactos</a></li> -->
              <li><a (click)="cambiarContrasenia()">Cambiar Contraseña</a></li>
            </ul>
  
          </div>
          
        </li>

        <li *ngFor="let item of menuData; let idx = index" [class.mm-active]="idx === 0">
          <a [routerLink]="item.router"  [attr.aria-expanded]="!!item?.children">
            <i class="{{item.class}}"></i>
            <span class="nav-label">{{item.text}}</span>
            <span [class.arrow]="item?.children" [class.fa]="item?.children"></span>
          </a>
          <ul *ngIf="item?.children" class="nav nav-second-level">
            <li *ngFor="let subItem of item?.children">
              <a [routerLink]="subItem.router">
                {{subItem.text}}
                <span [class.arrow]="subItem?.children" [class.fa]="subItem?.children"></span>
              </a>
                  <ul *ngIf="subItem?.children" class="nav nav-third-level">
                    <li *ngFor="let subSubItem of subItem?.children">
                      <a [routerLink]="subSubItem.router">
                          {{subSubItem.text}}
                      </a>
                    </li>
                  </ul>
            </li>
          </ul>
                  
        </li>
        <li class="nav-header">
          <a class="menu-profile">
            <span class="block m-t-xs font-bold">{{zonaHorariaServer}}</span>
            <span class="block m-t-xs font-bold">{{currentHourServer |date:'dd/MM/yyyy HH:mm'}}</span>
          </a>
        </li>
        
      </ul>
    </div>
  </nav>
</app-menu-side>
